/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Badge_BalancedInputs */

const en_model_badge_balanced = /** @type {(inputs: Model_Badge_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanced`)
};

const id_model_badge_balanced = /** @type {(inputs: Model_Badge_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seimbang`)
};

/**
* | output |
* | --- |
* | "Balanced" |
*
* @param {Model_Badge_BalancedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_badge_balanced = /** @type {((inputs?: Model_Badge_BalancedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Badge_BalancedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_badge_balanced(inputs)
	return en_model_badge_balanced(inputs)
});